// Bitácora del SISTEMA (contrato v2): lo que no es de una cotización — altas y cambios de usuarios, tablas de precios,
// llave, modelo y tope de la IA, entradas y salidas, política de acceso. La lee el director con GET /api/bitacora.
// El historial de CADA cotización sigue siendo su lista de eventos (DetalleCotizacion.eventos).
// Regla: el detalle NUNCA lleva la llave de Anthropic ni tokens (solo sus últimos 4 caracteres).
import { z } from 'zod';
import { Fecha, FechaHora, Id } from './basicos.ts';

export const ACCIONES_BITACORA = [
  'usuario_alta',
  'usuario_cambio',
  'precios',
  'ia_llave_guardada',
  'ia_llave_borrada',
  'ia_tope',
  /** Contrato v2: el director cambió el modelo de IA en Configuración. */
  'ia_modelo',
  'entrada',
  'salida',
  /** Contrato v2: cambió la política de acceso (hoy solo por .env al arrancar). */
  'politica_acceso',
  /** Un correo de acceso no salió (falla del proveedor) o se acabó el tope diario de Firebase. El que lo pidió solo
   *  ve el mensaje de siempre (no se le dice si el correo está dado de alta): Diego lo ve aquí. */
  'correo_acceso',
  /** Aprobación de un descuento (o de un precio debajo del margen mínimo) pedida, dada o negada (ADENDA A0b). */
  'aprobacion',
  /** El PDF no salió por la PLANTILLA o un candado del generador (no por los datos del vendedor): para Diego. */
  'pdf_fallo',
  /** Nube, tanda 2: saltó el fusible de lecturas de Datastore (las listas dejaron de responder, o la base se detuvo). */
  'base_lecturas',
  /** Etapa 3 (Diego, 12-oct, punto 3): alguien cambió la generación por kW de una cotización (de cuánto a cuánto y por qué). */
  'generacion',
  /** PAPELERA (Diego, 13-oct): alguien mandó una cotización a la papelera o Diego la recuperó. */
  'papelera',
] as const;
export const AccionBitacora = z.enum(ACCIONES_BITACORA);
export type AccionBitacora = z.infer<typeof AccionBitacora>;

export const ETIQUETA_ACCION_BITACORA: Readonly<Record<AccionBitacora, string>> = Object.freeze({
  usuario_alta: 'Alta de usuario',
  usuario_cambio: 'Cambio de usuario',
  precios: 'Tabla de precios',
  ia_llave_guardada: 'Llave de IA guardada',
  ia_llave_borrada: 'Llave de IA borrada',
  ia_tope: 'Tope de gasto de IA',
  ia_modelo: 'Modelo de IA',
  entrada: 'Entrada',
  salida: 'Salida',
  politica_acceso: 'Política de acceso',
  correo_acceso: 'Correo de acceso',
  aprobacion: 'Aprobación de precio',
  pdf_fallo: 'PDF que no salió (formato)',
  base_lecturas: 'Tope de lecturas de la base',
  generacion: 'Generación por kW de una cotización',
  papelera: 'Papelera de cotizaciones',
});

export const EntradaBitacora = z.strictObject({
  id: Id,
  en: FechaHora,
  /** null = el sistema (p. ej. el director creado desde DIRECTOR_CORREO). */
  usuario_id: Id.nullable(),
  /** Nombre de quien lo hizo AL LEER (el servidor lo junta con los usuarios). null = el sistema o usuario borrado. */
  usuario_nombre: z.string().trim().min(1).max(80).nullable(),
  accion: AccionBitacora,
  detalle: z.string().max(2_000),
});
export type EntradaBitacora = z.infer<typeof EntradaBitacora>;

/** Filtros de GET /api/bitacora (query string). Más reciente primero. */
export const ConsultaBitacora = z.strictObject({
  accion: AccionBitacora.optional(),
  usuario_id: Id.optional(),
  /** Fechas de Hermosillo, inclusive. */
  desde: Fecha.optional(),
  hasta: Fecha.optional(),
  limite: z.coerce.number().int().min(1).max(500).optional(),
});
export type ConsultaBitacora = z.infer<typeof ConsultaBitacora>;
